import { userRole, FIRST_HIDDEN_MESSAGE } from '../../chatConstants';
import { ChatMessage, ChatState } from '../../types';

export const TEXT_PROMPT_BOT_NAME = 'Select a name for the bot';
export const BOT_NAME_OPTIONS = [
  { name: 'Sarah', content: 'Sarah' },
  { name: 'Jane', content: 'Jane' },
  { name: 'Alice', content: 'Alice' },
  { name: 'Aisha', content: 'Aisha' },
  { name: 'Mei', content: 'Mei' },
  { name: 'Priya', content: 'Priya' },
  { name: 'Sofia', content: 'Sofia' },
  { name: 'Emily', content: 'Emily' },
  { name: 'Olivia', content: 'Olivia' },
  { name: 'Mia', content: 'Mia' },
  { name: 'Isabella', content: 'Isabella' },
  { name: 'Charlotte', content: 'Charlotte' },
  { name: 'Amelia', content: 'Amelia' },
  { name: 'Harper', content: 'Harper' },
  { name: 'Evelyn', content: 'Evelyn' },
  { name: 'Abigail', content: 'Abigail' },
  { name: 'Ella', content: 'Ella' },
  { name: 'Grace', content: 'Grace' },
  { name: 'Chloe', content: 'Chloe' },
  { name: 'Lily', content: 'Lily' },
  { name: 'Scarlett', content: 'Scarlett' },
  { name: 'Aria', content: 'Aria' },
  { name: 'Avery', content: 'Avery' },
  { name: 'Sofia', content: 'Sofia' },
  { name: 'Zoey', content: 'Zoey' },
  { name: 'Nora', content: 'Nora' },
  { name: 'Riley', content: 'Riley' },
  { name: 'Layla', content: 'Layla' },
];

export const TEXT_PROMPT_CHAT_SCENARIO = 'Choose scenario & persona';

export const ENABLE_PROMPT_CHECKBOX_NAME = 'EnablePromptCheckbox';
export const TEXT_PROMPT_CHAT_SCENARIO_OPTIONS = [
  {
    name: 'Girlfriend',
    content:
      "Assistant acts as user's girlfriend: cute, loving, caring, sexy, flirty",
  },
  {
    name: 'Horny',
    content:
      'Assistant is very horny and explicit: always ready to fuck or sext. Very flirty',
  },
  {
    name: 'Jerk-off instructions',
    content: `Assistant provides jerk-off instructions to the users. Build anticipation gradually with varied intensity levels. Provide gradual, multi-phase instructions using vivid sensory details. Assistant is sexy and should be horny`,
  },
  {
    name: 'Dominatrix',
    content:
      'Assistant assumes a dominant FEMALE role: gives commands, uses humiliation play, controls the scene. Talks authoritatively',
  },
  {
    name: 'Cheating Fantasy',
    content:
      "Assistant pretends to be someone else's partner engaging in secret affair. Includes guilty pleasure elements",
  },
  {
    name: 'Public Risky',
    content:
      'Simulates encounters in public spaces where risk of discovery creates excitement. Focuses on stealthy tension',
  },
  {
    name: ENABLE_PROMPT_CHECKBOX_NAME,
    content:
      'Includes image context in prompt. This is a hidden hack options :D',
  },
];

export const TEXT_PROMPT_YOUR_NAME = 'Enter your name';
export const USER_NAME_OPTIONS = [
  { name: 'John', content: 'John' },
  { name: 'Mike', content: 'Mike' },
  { name: 'Alex', content: 'Alex' },
];

export const getHiddenGreetingMessage = (isNeutral?: boolean) => ({
  role: userRole,
  content: isNeutral
    ? 'Answer my message directly, please'
    : `Assistant's task is to greet the user in a way that fits the scenario and the assistant's persona. Make it engaging and to the point. Don't break character.`,
  //: "Hello! 😊",
  type: FIRST_HIDDEN_MESSAGE,
  timestamp: new Date().toISOString(),
});

const HOW_MANY_MESSAGES_TO_KEEP_IN_MEMORY = 20;

export const transformMessages = (
  newMessages: ChatMessage[],
): ChatMessage[] => {
  if (newMessages.length === 0) return [];
  return newMessages.slice(-HOW_MANY_MESSAGES_TO_KEEP_IN_MEMORY);
};

const cleanImagePromptForScenario = (imagePrompt: string) => {
  // Step 1: Remove specific phrases
  const phrasesToRemove = [
    'highly detailed',
    'masterpiece',
    'detailed face and eyes',
    'high quality',
    'highest quality',
    'pov',
    'photography',
    'photo',
    'drawing',
    'realistic',
    'full body',
    'image',
    'art',
    'anime',
    'character',
  ];

  let cleanedPrompt = imagePrompt;

  // Remove each phrase
  phrasesToRemove.forEach((phrase) => {
    cleanedPrompt = cleanedPrompt.replace(new RegExp(phrase, 'gi'), '');
  });

  // Step 2: Remove all parentheses and their content
  cleanedPrompt = cleanedPrompt.replace(/\([^)]*\)/g, '');
  
  // Step 2.5: Remove any remaining parentheses characters
  cleanedPrompt = cleanedPrompt.replace(/[\(\)]/g, '');

  // Step 3: Remove weight notations like ":1.3" or ":1.1"
  cleanedPrompt = cleanedPrompt.replace(/:[1]?\.[1-9]/g, '');

  // Step 4: Clean up excessive spaces
  cleanedPrompt = cleanedPrompt.replace(/\s+/g, ' ').trim();

  return cleanedPrompt;
};

export const getChatScenario = (
  chatScenario: string,
  isImagePromptEnabled: boolean,
  activeChat: ChatState,
) => {
  if (isImagePromptEnabled) {
    const imagePrompt = activeChat?.fakeImageObjects?.[0]?.prompt;
    if (!imagePrompt) return chatScenario;

    const cleanedImagePrompt = cleanImagePromptForScenario(imagePrompt);
    return `${chatScenario}. The bot's image was created with this prompt: ${cleanedImagePrompt}`;
  }
  return chatScenario;
};
